import styled, { useTheme } from 'styled-components';

import { Icon } from '@/ui/Icon';
import { useLiveEventLocations } from '@/pages/LiveEvent/LiveEventLocationsContext';

const CommonTitle = styled.h3`
  margin-bottom: 24px;
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const IconWithLabelContainer = styled.div`
  gap: 16px;
  display: flex;
  align-items: center;
`;

const StyledDateAndTime = styled.div`
  ${({ theme }) => theme.typography.subheadline};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

export const LiveEventDateBlock = (): JSX.Element => {
  const { activeLocation } = useLiveEventLocations();
  const theme = useTheme();

  return (
    <>
      <CommonTitle>When</CommonTitle>
      <IconWithLabelContainer>
        <Icon icon={['far', 'calendar']} color={theme.colors.neutral.onContainer} size="lg" />
        <StyledDateAndTime>{activeLocation?.dateAndTime}</StyledDateAndTime>
      </IconWithLabelContainer>
    </>
  );
};
